export default __webpack_public_path__ + "static/media/eden.90f0edde.svg";